module.exports = __webpack_public_path__ + "img/lasource-36.d09a7068.jpg";